module.exports = __webpack_public_path__ + "static/media/ic-delete-upload.ac592fb7.svg";